import { render, staticRenderFns } from "./PopupPhoto.vue?vue&type=template&id=73bf57aa&scoped=true"
import script from "./PopupPhoto.vue?vue&type=script&lang=js"
export * from "./PopupPhoto.vue?vue&type=script&lang=js"
import style0 from "./PopupPhoto.vue?vue&type=style&index=0&id=73bf57aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bf57aa",
  null
  
)

export default component.exports